import { toast } from 'sonner';

import type { INotification } from '../types';
import { NotificationToast } from './NotificationToast';

/**
 * Dedicated Sonner Toaster id for notification arrival toasts. A second
 * `<Toaster id={NOTIFICATIONS_TOASTER_ID} expand position="top-right" />` in
 * App.tsx renders these (expanded, un-stacked); routing via `toasterId` keeps
 * the default bottom-right success/error toasts collapsed + unaffected.
 */
export const NOTIFICATIONS_TOASTER_ID = 'notifications';

interface ToastHandlers {
    onNavigate: (url: string) => void;
    onMarkRead: (id: string) => void;
}

/**
 * Fire a top-right arrival toast for a notification. Uses the notification id
 * as the toast id so a re-surfaced (coalesced) notification replaces its toast
 * instead of stacking. Clicking marks it read + navigates (if it has a URL).
 */
export function showNotificationToast(notification: INotification, handlers: ToastHandlers): void {
    toast.custom(
        (id) => (
            <NotificationToast
                notification={notification}
                onClick={() => {
                    handlers.onMarkRead(notification.id);
                    if (notification.actionUrl) handlers.onNavigate(notification.actionUrl);
                    toast.dismiss(id);
                }}
                onClose={() => toast.dismiss(id)}
            />
        ),
        {
            id: notification.id,
            toasterId: NOTIFICATIONS_TOASTER_ID,
            position: 'top-right',
            duration: 6000,
        },
    );
}
